<template v-if="list.length" lang="html">
  <table class="admin-table">
    <thead>
      <tr>
        <th class="column-id">
          ID
        </th>

        <th class="column-date" @click="setSortingMethod('created_at')">
          <span>{{ $tr('common.list.created') }}</span>
          <i v-if="sorting.name === 'created_at'" class="fa" :class="sortingIcon"></i>
        </th>

        <th class="column-name" @click="setSortingMethod('name')">
          {{ $tr('admin_console.company.candidate.table.info') }}
          <i v-if="sorting.name === 'name'" class="fa" :class="sortingIcon"></i>
        </th>

        <th class="column-company">
          {{ $tr('admin_console.company.candidate.table.company') }}
        </th>

        <th class="column-vacancy">
          {{ $tr('admin_console.company.candidate.table.vacancy') }}
        </th>

        <th class="column-status">
          {{ $tr('admin_console.company.candidate.table.status') }}
        </th>

        <th class="column-stage">
          {{ $tr('admin_console.company.candidate.table.stage') }}
        </th>

        <th class="column-questions">
          {{ $tr('admin_console.company.candidate.table.progress') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <candidate-row
        v-for="(item, index) in list"
        :model="item"
        :key="item.id"
      />
    </tbody>
  </table>
</template>
<script>
  import { STORE_PREFIX } from '../constants.js';
  import { mapGetters } from 'vuex';

  import CandidateRow from './Row.vue'

  export default {
    name: 'candidate-list',

    components: {
      CandidateRow
    },

    methods: {
      setSortingMethod (method) {
        const sorting = this.$store.getters[STORE_PREFIX + 'admin/candidates/sorting']

        this.$store.dispatch(STORE_PREFIX + 'admin/candidates/updateSorting', {
          name: method,
          order: (sorting.name !== method || sorting.order === 'desc') ? 'asc' : 'desc'
        })

        this.$emit('sort_change')
      }
    },

    computed: {
      ...mapGetters(STORE_PREFIX + 'admin', {
        sorting: 'candidates/sorting'
      }),

      sortingIcon () {
        return {
          'fa-caret-down': this.sorting.order === 'desc',
          'fa-caret-up': this.sorting.order === 'asc'
        }
      }
    },

    props: {
      list: Array
    }
  }
</script>

<style lang="scss" scoped>
  table thead th {
    cursor: default;
    font-size: 14px;

    &.column-date span { 
      white-space: normal;
      display: inline;
    }

    &.column-date,
    &.column-name,
    &.column-payment {
      cursor: pointer;
    }
  }

  .column-id {
    width: 4%;
  }

  .column-date {
    width: 11%;
  }

  .column-logo {
    width: 10%;
  }

  .column-name {
    width: 20%;
  }

  .column-payment {
    width: 10%;
  }

  .column-contact {
    width: 10%;
  }

  .column-location {
    width: 10%;
  }

  .column-user {
    width: 25%;
  }
</style>
